import script from "./WhatsAppButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./WhatsAppButton.vue?vue&type=script&setup=true&lang=ts"

import "./WhatsAppButton.vue?vue&type=style&index=0&id=278a42fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-278a42fb"]])

export default __exports__